module.exports = __webpack_public_path__ + "img/stan-miller.1a1802c6.jpg";